export default __webpack_public_path__ + "static/ekaterra_logo-b7b15f33e0592dd863b73e8f2d131294.png";